
import { Component, Vue, Prop } from "vue-property-decorator";
import { objAny } from "@/common/common-interface";
import {
  getMonitorPileData,
  getMonitorGunInfo
} from "@/api/api-operation-service";
import { getAlarmQuerys } from "@/api/api-basic";
import { getOrderGunChargingInfo } from "@/api/api-charge-service";
import { GunStatusColorEnum, PileStatusEnum } from "../gun-stauts-enum";
import chargeCurve from "./children/charge-curve.vue";
import tempCurve from "./children/temp-curve.vue";
import setPower from "./set-power.vue";
enum CurveTypeEnum {
  CHARGE_CURVE = "chargeCurve",
  TEMP_CURVE = "tempCurve"
}
@Component({
  components: {
    chargeCurve,
    tempCurve,
    "pi-set-power": setPower
  }
})
export default class PiSiteMonitor extends Vue {
  @Prop()
  isShowGunList!: boolean;

  @Prop()
  gunInfo!: objAny;

  @Prop()
  pileInfo!: objAny;

  key = "";
  status = 1;
  CurveTypeEnum = CurveTypeEnum;
  currentTab = CurveTypeEnum.CHARGE_CURVE;
  GunStatusColorEnum = GunStatusColorEnum;
  PileStatusEnum = PileStatusEnum;

  faultInfo: objAny = {};
  info: objAny = {};
  lastHistoryOrderInfo: objAny = {
    accountPkId: "",
    accountTypeDesc: "",
    carVin: "",
    chargeAmount: 0,
    chargeElect: 0,
    chargeMinutes: 0,
    chargeModeDesc: "",
    delayAmount: 0,
    orderNo: "",
    remainMinutes: 10
  };
  /**
   * 单个桩下枪数据
   */
  singlePileData: objAny = [];
  /**
   * 不同枪口装填对应不同的class
   */
  statusMapClass = {
    free: "pi-free",
    putGun: "pi-put-gun",
    full: "pi-charge-full",
    charge: "pi-charge",
    offline: "pi-offline",
    fault: "pi-fault",
    forbidden: "pi-forbidden",
    order: "pi-order"
  };
  /**
   * 不同枪类型对应图片
   */
  typeMapPic = {
    pileDc: this.$config.host + "/images/dc-stake.png",
    pileAc: this.$config.host + "/images/ac-stake.png"
  };

  /**
   * 初始进来
   */
  isInitIn = true;

  /**
   * 枪的基础信息
   */
  gunBaseInfo: objAny = {};

  thisPower: number | string = "";
  /**
   * 获取单个桩实时数据
   */
  async getSinglePile(): Promise<void> {
    const ret = await getMonitorPileData({ sn: this.pileInfo.pilePkId });
    if (ret.status == this["$config"].apiStatus) {
      this.singlePileData = ret.data;
    }
  }

  /**
   * 获取枪基础信息
   */
  async getGunBaseInfo(): Promise<void> {
    const pkid = this.isInitIn ? this.gunInfo.gunPkId : this.info.gunPkId;
    const ret = await getMonitorGunInfo({ gunPkId: pkid });
    if (ret.status == this["$config"].apiStatus) {
      this.gunBaseInfo = ret.data[0];
    }
  }

  /**
   * 获取历史订单最后一笔
   */
  async getLastHistoryOrder(): Promise<void> {
    const pkid = this.isInitIn ? this.gunInfo.gunPkId : this.info.gunPkId;
    const ret = await getOrderGunChargingInfo({ gunPkId: pkid });
    if (ret.status == this["$config"].apiStatus) {
      if (!ret.data.length) {
        return;
      }
      this.lastHistoryOrderInfo = ret.data[0];
    }
  }

  /**
   * 切换枪
   * @param item
   */
  switchGun(item: objAny): void {
    this.isInitIn = false;
    this.info = item;

    this.getGunBaseInfo();

    this.getLastHistoryOrder();
    if (this.info.gunStatus == 2) {
      this.getAlarmQuerys();
    }
  }

  public returnPower(power: number | string): void {
    this.thisPower = power;
  }

  public setPowerClick(): void {
    const setPower: objAny = this.$refs.setPower || {};
    setPower.open({
      pilePkId: this.pileInfo.pilePkId,
      gunPkId: this.gunInfo.gunPkId
    });
  }
  public setPowerSuccess(): void {
    console.log("设置成功");
    // this.currentTab = '';
  }
  /**
   * 设置当前一周时间
   */
  setWeekDay(): Date {
    return new Date(new Date().setDate(new Date().getDate() - 6));
  }
  async getAlarmQuerys(): Promise<void> {
    const startTime = this.$common.userDate(this.setWeekDay());
    const endTime = this.$common.userDate(new Date());

    const ret = await getAlarmQuerys({
      globalPageIndex: 1,
      globalPageSize: 1,
      alarmType: 1,
      pilePkId: this.pileInfo.pilePkId,
      alarmEndTime: endTime,
      alarmStartTime: startTime
    });
    if (ret.status === this.$config.apiStatus) {
      this.faultInfo = ret.data[0] || {};
    }
  }
  created(): void {
    if (this.gunInfo.gunStatus == 2) {
      this.getAlarmQuerys();
    }
    this.getSinglePile();
    this.getGunBaseInfo();

    this.getLastHistoryOrder();
  }
}
